/* eslint-disable react/self-closing-comp */
/* eslint-disable arrow-body-style */
import React from 'react';
import { useEventSearchFilterPanelStore } from '../../mothership/eventSearchFilterPanel.state';
import { eventSearchId } from '../../types';

/*
  Only re-render this component when loading changes
*/
export const EvtSearchLoadingAttr = () => {
  const loading = useEventSearchFilterPanelStore((state) => state.loading);
  const id = `${eventSearchId}FilterPanel`;
  return <div data-cy={id} data-loading={loading}></div>;
};
